<template>

    <form @submit.prevent="armazenar">

        <div class="row">

            <vc-mostra-mensagem-validacao></vc-mostra-mensagem-validacao>

            <div class="col-sm-12">
                <div class="form-group">
                    &ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;
                    <label class="switch switch-success"><input type="checkbox"
                                                                v-model="pessoa.proprietarioArrendatario"><span></span></label>&nbsp;Proprietários
                    / Arrendatários &ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;
                    <label class="switch switch-success"><input type="checkbox"
                                                                v-model="pessoa.remetente"><span></span></label>&nbsp;Remetentes
                </div>
            </div>

            <div class="col-xs-12 col-sm-6 col-md-4">
                <div class="form-group" :class="{'has-error': errors.has('tipo')}">
                    <label>Tipo</label>
                    <v-select v-model="pessoa.tipo" :options="[
                            {label: 'Físico', value: '1'},
                            {label: 'Jurídico', value: '2'},
                        ]" v-validate="'required'" data-vv-name="tipo"></v-select>
                </div>
            </div>

            <div v-if="pessoa.tipo != null && parseInt(pessoa.tipo.value)  == 1">
                <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group" :class="{'has-error': errors.has('nome')}">
                        <label>Nome</label>
                        <input type="text" class="form-control" v-model="pessoa.nome" v-validate="'required'"
                               data-vv-name="nome"/>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                        <label>CPF</label>
                        <the-mask :mask="'###.###.###-##'" type="text" :masked="true" v-model="pessoa.cpf"
                                  class="form-control" @input="verificaJaCadastrado('cpf')"></the-mask>
                    </div>
                </div>
            </div>

            <div v-if="pessoa.tipo != null && parseInt(pessoa.tipo.value) == 2">
                <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group" :class="{'has-error': errors.has('razao_social')}">
                        <label>Razão social</label>
                        <input type="text" class="form-control" v-model="pessoa.razao_social" v-validate="'required'"
                               data-vv-name="razao_social"/>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                        <label>Fantasia</label>
                        <input type="text" class="form-control" v-model="pessoa.fantasia" data-vv-name="fantasia"/>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                        <label>CNPJ</label>
                        <the-mask mask="##.###.###/####-##" type="text" :masked="true" v-model="pessoa.cnpj"
                                  class="form-control" @input="verificaJaCadastrado('cnpj')"></the-mask>
                    </div>
                </div>
            </div>

            <div class="col-xs-12 col-sm-6 col-md-4">
                <div class="form-group">
                    <label>Telefone</label>
                    <the-mask :mask="['(##) ####-####', '(##) #####-####']" :masked="true" v-model="pessoa.fone"
                              data-vv-name="fone" class="form-control"/>
                </div>
            </div>

            <div class="col-xs-12 col-sm-6 col-md-4">
                <div class="form-group">
                    <label>Telefone 2</label>
                    <the-mask :mask="['(##) ####-####', '(##) #####-####']" :masked="true" v-model="pessoa.fone2"
                              data-vv-name="fone" class="form-control"/>
                </div>
            </div>

            <div class="col-xs-12 col-sm-6 col-md-4">
                <div class="form-group">
                    <label>CEP</label>
                    <the-mask :mask="['##.###-###']" :masked="true" v-model="pessoa.cep" @blur.native="consultaCep"
                              data-vv-name="cep" class="form-control"/>
                </div>
            </div>

            <div class="col-xs-12 col-sm-6 col-md-4">
                <div class="form-group">
                    <label>Endereço</label>
                    <input type="text" class="form-control" v-model="pessoa.endereco"/>
                </div>
            </div>

            <div class="col-xs-12 col-sm-6 col-md-4">
                <div class="form-group">
                    <label>Número</label>
                    <the-mask :mask="['########']" :masked="true" v-model="pessoa.endereco_nro"
                              data-vv-name="endereco_nro" class="form-control"/>
                </div>
            </div>

            <div class="col-xs-12 col-sm-6 col-md-4">
                <div class="form-group">
                    <label>Bairro</label>
                    <input type="text" class="form-control" v-model="pessoa.bairro"/>
                </div>
            </div>

            <div class="col-xs-12 col-sm-6 col-md-4">
                <div class="form-group">
                    <label>Complemento</label>
                    <input type="text" class="form-control" v-model="pessoa.complemento"/>
                </div>
            </div>

            <div v-if="pessoa.remetente" class="col-xs-12 col-sm-6 col-md-4">
                <div class="form-group">
                    <label>Senha</label>
                    <input type="text" class="form-control" v-model="pessoa.observacao"/>
                </div>
            </div>

            <div class="col-xs-12 col-sm-6 col-md-4">
                <div class="form-group">
                    <label>Email</label>
                    <input type="email" class="form-control" v-model="pessoa.email"/>
                </div>
            </div>

            <div class="col-xs-12 col-sm-6 col-md-4">
                <div class="form-group">
                    <label>Segundo email</label>
                    <input type="email" class="form-control" v-model="pessoa.email2"/>
                </div>
            </div>

            <div class="col-xs-12 col-sm-6 col-md-4">
                <div class="form-group">
                    <label>Terceiro email</label>
                    <input type="email" class="form-control" v-model="pessoa.email3"/>
                </div>
            </div>

            <div class="col-xs-12 col-sm-6 col-md-4">
                <vc-pesquisa
                        :selecionado="pessoa.cidade"
                        @input="(cidade) => { pessoa.cidade_id = cidade.id}"
                        label="Cidade"
                        nome-input="cidade_id"
                        :selecionado-config="{label : 'nome', campo : 'id'}"
                        url-busca="api/cidades/pesquisa"
                        :campos-table="[ {'label' : 'Nome', 'campo' : 'nome'}, {'label' : 'Código IBGE', 'campo' : 'codigo_ibge'}]"
                        obrigatorio="cidade">
                </vc-pesquisa>
            </div>

            <div class="col-xs-12 col-sm-6 col-md-4" v-if="pessoa.remetente">
                <label>Enviar sugestão de adubação</label>
                <v-select v-model="pessoa.relatorio_auto" :options="[
                        {label: 'Enviar', value: '1'},
                        {label: 'Não enviar', value: '0'},
                    ]" data-vv-name="relatorio_auto"></v-select>
            </div>
        </div>

        <div v-if="pessoa.remetente" class="row">
            <div class="col-xs-12">
                <h4 class="title">Tabela de preços</h4>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Química (R$)</label>
                    <money v-model="preco.valor_quimica" class="form-control"></money>
                    <!--<money v-model="preco.desconto_quimica" class="form-control"></money>-->
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Física (R$)</label>
                    <money v-model="preco.valor_fisica" class="form-control"></money>
                    <!--<money v-model="preco.desconto_fisica" class="form-control"></money>-->
                </div>
            </div>

             <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Química e Física (R$)</label>
                    <money v-model="preco.valor_quimica_fisica" class="form-control"></money>
                    <!--<money v-model="preco.desconto_fisica" class="form-control"></money>-->
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Extrato de saturação (R$)</label>
                    <money v-model="preco.valor_extrato_saturacao" class="form-control"></money>
                    <!--<money v-model="preco.desconto_extrato_saturacao" class="form-control"></money>-->
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Metais pesados (R$)</label>
                    <money v-model="preco.valor_metais_pesados" class="form-control"></money>
                    <!--<money v-model="preco.desconto_metais_pesados" class="form-control"></money>-->
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Semente germinação (R$)</label>
                    <money v-model="preco.valor_germinacao" class="form-control"></money>
                    <!--<money v-model="preco.desconto_germinacao" class="form-control"></money>-->
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Valor API (R$)</label>
                    <money v-model="preco.valor_analise_api" class="form-control"></money>
                    <!--<money v-model="preco.desconto_germinacao" class="form-control"></money>-->
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Cobrar análise externa</label>
                        <v-select v-model="preco.cobrar_analise_externa_site" :options="[
                                {label: 'Sim', value: '1'},
                                {label: 'Não', value: '0'},
                        ]" data-vv-name="cobrar_analise_externa"></v-select>
                </div>
            </div>

            <div class="col-xs-12 col-sm-4" v-if="preco.cobrar_analise_externa_site != undefined" v-show="preco.cobrar_analise_externa_site.value == '1'">
                <div class="form-group">
                    <label>Valor análise externa (R$)</label>
                    <money v-model="preco.valor_analise_externa_site" class="form-control"></money>
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Pacote de novos elementos (R$)</label>
                    <money v-model="preco.valor_pacote_elementos_1" class="form-control"></money>
                    <!--<money v-model="preco.desconto_vigor" class="form-control"></money>-->
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Ph Calc2 (R$)</label>
                    <money v-model="preco.valor_ph_calc2" class="form-control"></money>
                    <!--<money v-model="preco.desconto_vigor" class="form-control"></money>-->
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Fosforo Resina (R$)</label>
                    <money v-model="preco.valor_fosforo_resina" class="form-control"></money>
                    <!--<money v-model="preco.desconto_vigor" class="form-control"></money>-->
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Ferro (R$)</label>
                    <money v-model="preco.valor_ferro" class="form-control"></money>
                    <!--<money v-model="preco.desconto_vigor" class="form-control"></money>-->
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Condutividade (R$)</label>
                    <money v-model="preco.valor_condutividade" class="form-control"></money>
                    <!--<money v-model="preco.desconto_vigor" class="form-control"></money>-->
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Nitrogenio azoto (R$)</label>
                    <money v-model="preco.valor_nitrogenio_azoto" class="form-control"></money>
                    <!--<money v-model="preco.desconto_vigor" class="form-control"></money>-->
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Silicio (R$)</label>
                    <money v-model="preco.valor_silicio" class="form-control"></money>
                    <!--<money v-model="preco.desconto_vigor" class="form-control"></money>-->
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Semente vigor (R$)</label>
                    <money v-model="preco.valor_vigor" class="form-control"></money>
                    <!--<money v-model="preco.desconto_vigor" class="form-control"></money>-->
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Tecido vegetal (R$)</label>
                    <money v-model="preco.valor_tecido_vegetal" class="form-control"></money>
                    <!--<money v-model="preco.desconto_tecido_vegetal" class="form-control"></money>-->
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Fertilizante (R$)</label>
                    <money v-model="preco.valor_fertilizante" class="form-control"></money>
                    <!--<money v-model="preco.desconto_fertilizante" class="form-control"></money>-->
                </div>
            </div>
        </div>

        <div v-if="pessoa.remetente" class="row">
            <div class="col-xs-12">
                <h4 class="title">Configurações diversas</h4>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Forma de pagamento padrão</label>
                    <v-select v-model="preco.forma_pagamento_padrao"
                              @change="verificaFormaBoleto"
                              :options="[{value: '',label: 'Nenhuma'},
                                            {value: 'FATURADA',label: 'À vista'},
                                            {value: 'NFATURAR',label: 'À prazo'},
                                            {value: 'BOLETO',label: 'Boleto bancário'}]"
                    ></v-select>
                </div>
            </div>

            <div v-if="temBoleto">
                <div class="col-xs-12 col-sm-4">
                    <div class="form-group">
                        <label>Dias para vencimento (boleto)</label>
                        <the-mask mask="##" type="text" :masked="true" v-model="preco.dias_vencimento_boleto"
                                  class="form-control"></the-mask>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4">
                    <div class="form-group">
                        <label>Boleto para</label>
                        <v-select v-model="preco.boleto_para"
                                  :options="[{value: 'REMETENTE',label: 'Remetente'}, {value: 'PROPRIETARIO',label: 'Proprietário'}, {value: 'ARRENDATARIO',label: 'Arrendatário'}]"
                        ></v-select>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4">
                    <div class="form-group">
                        <label>Gerar boleto no</label>
                        <v-select v-model="preco.gera_boleto"
                                  :options="[{value: 'RESULTADO',label: 'Resultado'}, {value: 'PROTOCOLO',label: 'Protocolo'}]"
                        ></v-select>
                    </div>
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Pendentes no site</label>
                    <v-select v-model="preco.pendente_site"
                              :options="[{value: '0',label: 'Não'}, {value: '1',label: 'Sim'}]"></v-select>
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Sugestão tabaco</label>
                    <v-select v-model="preco.sugestao_tabaco"
                              :options="[{value: '0',label: 'Não'}, {value: '1',label: 'Sim'}]"></v-select>
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Imprimir laudo (resultado)</label>
                    <v-select v-model="preco.imprime_resultado"
                              :options="[{value: '0',label: 'Não'}, {value: '1',label: 'Sim'}]"></v-select>
                </div>
            </div>
        </div>


        <div class="row">
            <div class="col-xs-12 col-md-4">
                <div class="form-group">
                    <button type="submit" class="btn btn-success">Salvar</button>&nbsp;
                    <router-link :to="{name: 'pessoas'}" class="btn btn-danger">Cancelar</router-link>
                </div>
            </div>
        </div>
    </form>

</template>

<script>
    import VcPesquisa from '@/components/Form/Pesquisa'
    import VcMostraMensagemValidacao from '@/components/Form/MostraMensagemValidacao'
    import ValidaCpfCnpjCep from './service/valida_cpf_cnpj_cep'

    export default {
        components: {
            VcPesquisa,
            VcMostraMensagemValidacao
        },
        data() {
            return {
                modo: null,
                temBoleto: {
                    type: Boolean,
                    default: false
                },
                pessoa: {
                    tipo: {label: 'Físico', value: '1'},
                    relatorio_auto: {label: 'Enviar', value: '1'}
                },
                preco: {}
            }
        },

        methods: {
            verificaFormaBoleto(valor) {
                this.$set(this, 'temBoleto', valor.value === 'BOLETO')
            },
            verificaJaCadastrado(nomeCampo) {
                let executaAjax = false;
                let valor = this.pessoa[nomeCampo]

                if (nomeCampo == 'cpf' && valor.length == 14 && ValidaCpfCnpjCep.validaCPF(valor)) {
                    executaAjax = true
                } else if (nomeCampo == 'cnpj' && valor.length == 18 && ValidaCpfCnpjCep.validaCNPJ(valor)) {
                    executaAjax = true
                }

                if (!executaAjax) {
                    return;
                }

                this.$http.post('api/pessoas/verifica-pessoa-cadastrada', {
                    'nomeCampo': nomeCampo,
                    'valor': valor
                }).then((response) => {
                    if (response.data.id > 0 && response.data.id != this.pessoa.id) {
                        window.swal('Atenção', 'Pessoa já cadastrada.', 'warning')
                        return this.pessoa[nomeCampo] = '';
                    }
                })
            },
            armazenar() {

                this.$validator.validate().then(valid => {
                    if (!valid) {
                        return null;
                    }

                    let pessoa = this.pessoa;

                    if (!pessoa.remetente && !pessoa.proprietarioArrendatario) {
                        return window.swal('Atenção', 'Pessoa tem que ser um proprietário ou remetente.', 'warning')
                    }

                    if (pessoa.remetente) {
                        this.$set(this.preco, 'forma_pagamento_padrao', this.preco.forma_pagamento_padrao != null ? this.preco.forma_pagamento_padrao.value : 'FATURADA')
                        this.$set(this.preco, 'pendente_site', this.preco.pendente_site != null ? this.preco.pendente_site.value : '0')
                        this.$set(this.preco, 'sugestao_tabaco', this.preco.sugestao_tabaco != null ? this.preco.sugestao_tabaco.value : '0')
                        this.$set(this.preco, 'imprime_resultado', this.preco.imprime_resultado != null ? this.preco.imprime_resultado.value : '0')
                        this.$set(this.preco, 'gera_boleto', this.preco.gera_boleto != null ? this.preco.gera_boleto.value : 'RESULTADO')
                        if (this.preco.boleto_para != null && this.preco.boleto_para.value != null) {
                            this.$set(this.preco, 'boleto_para', this.preco.boleto_para.value)
                        }
                        pessoa.preco = this.preco
                        pessoa.preco.cobrar_analise_externa_site = pessoa.preco.cobrar_analise_externa_site != null ? pessoa.preco.cobrar_analise_externa_site.value : '0'
                    }

                    pessoa.ativo = 1;
                    pessoa.tipo = pessoa.tipo.value;
                    pessoa.relatorio_auto = pessoa.relatorio_auto.value;

                    let controlePromise = (promise) => {
                        promise.then(() => {
                            window.swal("Sucesso", "Pessoa armazenada com sucesso!", "success");
                            this.$router.push({name: 'pessoas'});
                        }).catch((response) => {
                            return window.swal("Atenção", "Não foi possível armazenar a pessoa. " + response.message, "warning");
                        });
                    };

                    if (this.modo === 'editar') {
                        controlePromise(this.$http.put('api/pessoas/' + pessoa.id, pessoa))
                    } else {
                        controlePromise(this.$http.post('api/pessoas', pessoa))
                    }
                });
            },
            async consultaCep () {
                let retorno = await ValidaCpfCnpjCep.consultaCep(this.pessoa.cep, this.$http)
                if (retorno !== null) {
                    this.$set(this.pessoa, 'endereco', retorno.logradouro)
                    this.$set(this.pessoa, 'bairro', retorno.bairro)
                    this.$set(this.pessoa, 'complemento', retorno.complemento)
                    this.$set(this.pessoa, 'cidade', retorno.cidade)
                }
            }
        },

        async mounted() {
            let model = {}
            if (this.$route.name == 'pessoas.editar') {
                await this.$http.post(`api/pessoas/show`, {nomeCampo: 'id', valor: this.$route.params.id})
                    .then((response) => model = response.data)
                    .catch(error => {
                        throw Error(error)
                    })
                if (model.valores == null) {
                    model.valores = {};
                }
                model.tipo = {label: (model.tipo == 1 ? 'Físico' : 'Jurídico'), value: model.tipo}
                model.relatorio_auto = {label: (model.relatorio_auto == '1' ? 'Enviar' : 'Não enviar'), value: model.relatorio_auto}
                model.remetente = model.fornecedor == 1;
                model.proprietarioArrendatario = model.tecnico_agricola == 1;
                this.$set(this, 'pessoa', model)

                if (model.remetente) {
                    if (this.pessoa.preco != null) {
                        let preco = this.pessoa.preco
                        preco.gera_boleto = {
                            value: this.pessoa.preco.gera_boleto,
                            label: (this.pessoa.preco.gera_boleto === 'RESULTADO' ? 'Resultado' : 'Protocolo')
                        }
                        preco.boleto_para = {
                            value: this.pessoa.preco.boleto_para,
                            label: (this.pessoa.preco.boleto_para === 'PROPRIETARIO' ? 'Proprietário' : (this.pessoa.preco.boleto_para === 'ARRENDATARIO' ? 'Arrendatário' : 'Remetente'))
                        }
                        preco.imprime_resultado = {
                            value: this.pessoa.preco.imprime_resultado,
                            label: parseInt(this.pessoa.preco.imprime_resultado) ? "Sim" : "Não"
                        }
                        preco.pendente_site = {
                            value: this.pessoa.preco.pendente_site,
                            label: parseInt(this.pessoa.preco.pendente_site) ? "Sim" : "Não"
                        }
                        preco.sugestao_tabaco = {
                            value: this.pessoa.preco.sugestao_tabaco,
                            label: parseInt(this.pessoa.preco.sugestao_tabaco) ? "Sim" : "Não"
                        }

                        preco.cobrar_analise_externa_site = {
                            value: this.pessoa.preco.cobrar_analise_externa_site,
                            label: parseInt(this.pessoa.preco.cobrar_analise_externa_site) ? "Sim" : "Não"
                        }

                        preco.valor_analise_api = this.pessoa.preco.valor_analise_api != null ? this.pessoa.preco.valor_analise_api : 0
                        preco.valor_quimica_fisica = this.pessoa.preco.valor_quimica_fisica != null ? this.pessoa.preco.valor_quimica_fisica : 0
                        preco.valor_extrato_saturacao = this.pessoa.preco.valor_extrato_saturacao != null ? this.pessoa.preco.valor_extrato_saturacao : 0
                        preco.valor_metais_pesados = this.pessoa.preco.valor_metais_pesados != null ? this.pessoa.preco.valor_metais_pesados : 0
                        preco.valor_germinacao = this.pessoa.preco.valor_germinacao != null ? this.pessoa.preco.valor_germinacao : 0
                        preco.valor_analise_api = this.pessoa.preco.valor_analise_api != null ? this.pessoa.preco.valor_analise_api : 0
                        preco.cobrar_analise_externa_site = this.pessoa.preco.cobrar_analise_externa_site != null ? this.pessoa.preco.cobrar_analise_externa_site : '0'
                        preco.valor_analise_externa_site = this.pessoa.preco.valor_analise_externa_site != null ? this.pessoa.preco.valor_analise_externa_site : '0'
                        preco.valor_pacote_elementos_1 = this.pessoa.preco.valor_pacote_elementos_1 != null ? this.pessoa.preco.valor_pacote_elementos_1 : 0
                        preco.valor_ph_calc2 = this.pessoa.preco.valor_ph_calc2 != null ? this.pessoa.preco.valor_ph_calc2 : 0
                        preco.valor_fosforo_resina = this.pessoa.preco.valor_fosforo_resina != null ? this.pessoa.preco.valor_fosforo_resina : 0
                        preco.valor_ferro = this.pessoa.preco.valor_ferro != null ? this.pessoa.preco.valor_ferro : 0
                        preco.valor_condutividade = this.pessoa.preco.valor_condutividade != null ? this.pessoa.preco.valor_condutividade : 0
                        preco.valor_nitrogenio_azoto = this.pessoa.preco.valor_nitrogenio_azoto != null ? this.pessoa.preco.valor_nitrogenio_azoto : 0
                        preco.valor_silicio = this.pessoa.preco.valor_silicio != null ? this.pessoa.preco.valor_silicio : 0
                        preco.valor_vigor = this.pessoa.preco.valor_vigor != null ? this.pessoa.preco.valor_vigor : 0
                        preco.valor_tecido_vegetal = this.pessoa.preco.valor_tecido_vegetal != null ? this.pessoa.preco.valor_tecido_vegetal : 0
                        preco.valor_fertilizante = this.pessoa.preco.valor_fertilizante != null ? this.pessoa.preco.valor_fertilizante : 0
                        this.$set(this, 'preco', preco)
                    }
                }


                this.$set(this, 'modo', 'editar');
                this.$store.dispatch('removeEditingModel')
            } else {
                this.$set(this, 'modo', 'adicionar');

                this.preco.forma_pagamento_padrao = {value: 'FATURADA', label: 'À vista'}
                this.preco.imprime_resultado = {value: '0', label: "Não"}
                this.preco.pendente_site = {value: '0', label: "Não"}
            }
            this.$set(this, 'temBoleto', this.preco.id != undefined ? this.preco.forma_pagamento_padrao.value === "BOLETO" : false)
            this.$store.dispatch('setTitle', this.modo === 'editar' ? 'Editar pessoa' : 'Adicionar pessoa')
        }
    }
</script>

